import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import useLineItemDetails from '../AdFacebookCreate/AdFacebookCreateForm/hooks/useLineItemDetails'

import { ReactComponent as WarningIcon } from '../../../../assets/icons/warning-icon.svg'
import Button from '../../../../components/Button'

import { redirectTo } from '../../../../helpers/url'

import { closeForm, openForm } from '../../../../modules/actions/forms'

import { campaignSelector } from '../../../../modules/selectors/campaigns'
import { facebookRightUploadAdCampaignSelector } from '../../../../modules/selectors/rights'
import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { ROUTE_PARAMS, ROUTES } from '../../../../constants/routes'
import { LINE_ITEM_FACEBOOK_EDIT } from '../../../../constants/forms'
import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'

import useStyles from './styles'
import useDrawerFormStyles from '../../../../styles/common/drawerForms'

const AdSetEndDateWarning = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { id: campaignId } = useSelector(campaignSelector)
  const rightCampaign = useSelector(facebookRightUploadAdCampaignSelector)
  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)

  const rightCampaignId = rightCampaign?.id

  const { lineItemId } = useLineItemDetails()

  const editAdSetHandler = useCallback(() => {
    dispatch(closeForm())

    redirectTo(`${ROUTES.campaignsSummary}`, {
      [ROUTE_PARAMS.platform]: FACEBOOK_PLATFORM,
      [ROUTE_PARAMS.adAccount]: selectedAdAccountId,
      [ROUTE_PARAMS.campaignId]: campaignId || rightCampaignId
    })

    dispatch(openForm({ id: lineItemId, formName: LINE_ITEM_FACEBOOK_EDIT }))
  }, [dispatch, selectedAdAccountId, campaignId, rightCampaignId, lineItemId])

  return (
    <section className={drawerFormClasses.section}>
      <div className={classes.warningIcon}>
        <WarningIcon />
      </div>
      <p>
        {t(
          "Ads can't be created in ad sets that have ended. Please go back and edit the ad set end date to be able to create an ad."
        )}
      </p>
      <div className={classes.warningFooter}>
        <Button onClick={editAdSetHandler}>{t('Edit ad set')}</Button>
      </div>
    </section>
  )
}

export default AdSetEndDateWarning
